import React, {PropsWithChildren} from "react";
import cx from "classnames";

import {Spinner} from "./Spinner";

type Props = Readonly<{
  active?: boolean;
  className?: string;
}>;

export const BackdropSpinner = ({
  active,
  className,
  children,
}: PropsWithChildren<Props>) => (
  <div className={cx("spinner-backdrop", className)}>
    {active && <Spinner backdrop />}
    {children}
  </div>
);
